import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex items-center text-gray-700" }
const _hoisted_4 = { class: "w-40 sm:w-48 truncate font-light" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex items-center text-gray-700" }
const _hoisted_8 = { class: "w-40 sm:w-48 truncate font-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_layouts_auth_sidebar_content_submenu = _resolveComponent("layouts-auth-sidebar-content-submenu")!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: menu.id
      }, [
        (menu.menu_category_id == 2)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: ($event: any) => (_ctx.pushRoleCategoryList(menu.role_slug)),
              class: "flex items-center justify-between cursor-pointer hover:bg-gray-200 w-full px-4 py-2"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-5 mr-2",
                  path: menu.icon
                }, null, 8, ["path"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(menu.title), 1),
                  (_ctx.validateUrl(menu.url) === _ctx.LINK_STATUS.external)
                    ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                        key: 0,
                        class: "w-4",
                        path: _ctx.mdiOpenInNew
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: ($event: any) => (_ctx.validateUrl(menu.url) ? _ctx.externalOrInternalLink(menu.url, menu.open) : _ctx.handleToggle(index)),
              class: _normalizeClass(["flex items-center justify-between cursor-pointer hover:bg-gray-200 w-full px-4 py-2", [menu.url === _ctx.currentUrl ? 'bg-blue-200': '']])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-5 mr-2",
                  path: menu.icon
                }, null, 8, ["path"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(menu.title), 1),
                  (_ctx.validateUrl(menu.url) === _ctx.LINK_STATUS.external)
                    ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                        key: 0,
                        class: "w-4",
                        path: _ctx.mdiOpenInNew
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (!_ctx.validateUrl(menu.url) && Array.isArray(menu.menu_subs) && menu.menu_subs.length)
                ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                    key: 0,
                    class: _normalizeClass(["w-6 transform transition-transform duration-500 cursor-pointer", _ctx.isOpenSubmenu[index] ? 'rotate-90' : 'rotate-0']),
                    path: _ctx.mdiChevronRight
                  }, null, 8, ["class", "path"]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5)),
        (!_ctx.validateUrl(menu.url) && Array.isArray(menu.menu_subs) && menu.menu_subs.length)
          ? (_openBlock(), _createBlock(_component_layouts_auth_sidebar_content_submenu, {
              key: 2,
              menuSubs: menu.menu_subs,
              isOpen: _ctx.isOpenSubmenu[index]
            }, null, 8, ["menuSubs", "isOpen"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}